// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { PlatformSecurity, SessionData, SessionUser } from 'features/Security/state/types';

export interface ActionLoginApi extends Action {
    loggedInObject: any
}


export const postLoginApi = (loggedInObject: any): ActionLoginApi => ({
    type: ACTIONS.POST_LOGIN_API_REQUEST,
    loggedInObject
});


export interface ActionLoginApiSuccess extends Action {
    accessToken: string
    user:SessionUser
}

export const postLoginApiSuccess = (accessToken: string, user: SessionUser): ActionLoginApiSuccess => ({
    type: ACTIONS.POST_LOGIN_API_SUCCESS,
    accessToken,
    user
});

export const postLoginError = (error: any): Action & { error: any } => ({
    type: ACTIONS.POST_LOGIN_API_ERROR,
    error
});

export interface ActionSetIsLoggedIn extends Action {
    isLoggedIn: boolean
    user?:SessionUser
}

export const setIsLoggedIn = (isLoggedIn = true, user?:SessionUser): ActionSetIsLoggedIn => ({
    type: ACTIONS.SECURITY_IS_LOGGED_IN,
    isLoggedIn,
    user
});




export const postUserDataApi = (loggedInObject: any): ActionLoginApi => ({
    type: ACTIONS.POST_USERDATA_API_REQUEST,
    loggedInObject
});


export interface ActionUserDataApiSuccess extends Action {
    accessToken: string
    user:SessionUser
}

export const postUserDataApiSuccess = (accessToken: string, user: SessionUser): ActionLoginApiSuccess => ({
    type: ACTIONS.POST_USERDATA_API_SUCCESS,
    accessToken,
    user
});

export const postUserDataError = (error: any): Action & { error: any } => ({
    type: ACTIONS.POST_USERDATA_API_ERROR,
    error
});

export interface ActionBlurApp extends Action {
    blurAPP: boolean
}

export const blurAppRequest = (blurAPP: boolean): ActionBlurApp => ({
    type: ACTIONS.BLUR_APP,
    blurAPP
});


export const getPlatformSecurityApi = () => ({
    type: ACTIONS.GET_PLATFORM_SECURITY_API_REQUEST,
});


export interface ActionPlatformSecuritySuccess extends Action {
    platformSecurity: PlatformSecurity;
}

export const getPlatformSecurityApiSuccess = (platformSecurity: PlatformSecurity): ActionPlatformSecuritySuccess => ({
    type: ACTIONS.GET_PLATFORM_SECURITY_API_SUCCESS,
    platformSecurity
});

export const getPlatformSecurityError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_PLATFORM_SECURITY_API_ERROR,
    error
});

